import { Component, ChangeDetectorRef, ViewChild, Input, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { IonicPage, NavController, NavParams, Events, Content, Navbar } from 'ionic-angular';

import { BrComService } from '../../service/BrComService';
import { Contato } from '../../models/contato';
import { ContatoLocalProvider } from '../../providers/contato-local/contato-local';
import { ContatoProvider } from '../../providers/contato/contato';
import { FotoProvider } from '../../providers/foto/foto';
import { Mensagem, OrigemMensagem, ArquivoMensagem } from '../../models/mensagem';
import { MensagemProvider } from '../../providers/mensagem/mensagem';
import { Subscription } from 'rxjs';
import { ConversaContato } from '../shared/conversa/conversa-contato';
import { EmpresaLocalProvider } from '../../providers/empresa-local/empresa-local';
import { ConversaPage } from '../conversa/conversa';

@IonicPage()
@Component({
  selector: 'page-conversa-contato',
  templateUrl: 'conversa-contato.html',
  encapsulation: ViewEncapsulation.None
})
export class ConversaContatoPage extends ConversaContato {

  @ViewChild(Content) content: Content;
  @ViewChild(Navbar) navBar: Navbar;

  public contato: Contato;
  public mensagens: Mensagem[];
  public possuiMensagensAntigas: boolean;

  private subs: Subscription;

  constructor(public changeDetectorRef: ChangeDetectorRef,
    public navCtrl: NavController,
    private navParams: NavParams,
    private events: Events,
    private contatoProvider: ContatoProvider,
    private contatoLocalProvider: ContatoLocalProvider,
    empresaLocalProvider: EmpresaLocalProvider,
    mensagemProvider: MensagemProvider,
    fotoProvider: FotoProvider,
    brComService: BrComService) {
      super(mensagemProvider, empresaLocalProvider, brComService, fotoProvider);
    this.contato = this.navParams.get('contato');
    this.possuiMensagensAntigas = true;
    this.events.subscribe(`msg.contato.${this.contato.idContato}`, (mensagem: Mensagem) => {
      this.contato.mensagens.push(mensagem);
      this.changeDetectorRef.detectChanges();
      this.scrollBottom(this.content);
      this.notificarMensagensLidas();
    });
    this.subs = new Subscription();

    const sub = this.contatoLocalProvider.$contatos.skip(1).subscribe(
      contatos => {
        // caso o contato tenha sido removido por outro aparelho e estiver aberto neste
        if (!contatos.some(c => c.idContato === this.contato.idContato)) {
          this.navCtrl.setRoot(ConversaPage);
        }

        // ver uma forma de remover isso
        this.contato.mensagens = this.contatoLocalProvider.getContato(this.contato.idContato).mensagens || [];
        this.changeDetectorRef.detectChanges();
      }
    );
    this.subs.add(sub);
  }

  ionViewWillLeave() {
    this.events.unsubscribe(`msg.contato.${this.contato.idContato}`);
    this.contatoLocalProvider.removerMensagensAcimaDoLimite(this.contato.idContato);
    this.subs.unsubscribe();
  }

  ionViewWillEnter() {
    setTimeout(() => {
      this.content.scrollToBottom(0);
    }, 50);
    this.notificarMensagensLidas();
    this.brComService.confirmaUsuarioLogado(this.empresa.CodEmpresa, this.empresa.CodUsuario);
  }

  private notificarMensagensLidas(): void {
    if (this.hasMensagensNaoLidas()) {
      this.contatoLocalProvider.marcarMensagensDestinatarioLidas(this.contato.idContato);
      this.contatoProvider.notificarMensagensLidas(this.contato.idContato, this.brComService.getIdDevice()).subscribe();
    }
  }

  private hasMensagensNaoLidas(): boolean {
    const result = this.contato.mensagens.find(m => m.idUsuarioOrigem == this.contato.idUsuario && !m.statusMensagemLida)
    if (result) {
      return true;
    }
    return false;
  }

  public getMensagensAntigas(infinity: any): void {
    const mensagensContato = this.contato.mensagens;
    const idEnvioMaisAntigo = mensagensContato[0].idEnvio;
    this.contatoProvider.getMensagensAntigasContato(this.contato.idContato, idEnvioMaisAntigo).subscribe(
      mensagens => {
        if (mensagens && mensagens.length > 0) {
          this.contato.mensagens = mensagens.concat(mensagensContato);
          this.contatoLocalProvider.updateContato(this.contato);
        } else {
          this.possuiMensagensAntigas = false;
        }
      }, () => {
        infinity.complete();
      }, () => {
        infinity.complete();
      }
    )
  }

  public podePegarMensagensAntigas(): boolean {
    return this.possuiMensagensAntigas && this.contato.mensagens && this.contato.mensagens.length >= this.contatoLocalProvider.limiteDeMensagens;
  }
  
  private atualizarMensagemComFalhaNoEnvio(msg: Mensagem) {
    this.contato.mensagens.find(m => m.idEnvio === msg.idEnvio).falhaNoEnvio = true;
    this.changeDetectorRef.detectChanges();
    // se a a conversa está no fim seria legal dar um scroll, caso contrario não fazer nada
    this.contatoLocalProvider.atualizarMensagem(this.contato.idContato, msg);
  }


  public async enviarMensagem(mensagem: string): Promise<void> {
    if (mensagem.trim() === "") {
      return;
    }
    const msg = this.criarMensagemSimplesEnvio(mensagem, this.contato.idUsuario);
    this.adicionarNovaMensagem(msg);
    this.contatoProvider.enviarMensagemSimples(this.contato.idContato, this.brComService.getIdDevice(), mensagem).subscribe(
      (idEnvio: number) => {
        this.contato.mensagens.find(m => m.idEnvio === msg.idEnvio).idEnvio = idEnvio;
        this.contatoLocalProvider.atualizarMensagemEnviada(this.contato.idContato, msg.idEnvio, idEnvio);
      }, (error) => {
        this.atualizarMensagemComFalhaNoEnvio(msg);
      }
    )
  }

  public enviarImagem(imagem: File): void {
    const msg = this.criarMensagemImagemEnvio(this.contato.idUsuario);
    this.adicionarNovaMensagem(msg);
    this.mensagemProvider.uploadFirebase(imagem).then(
      url => {
        msg.link = url;
        const i = this.contato.mensagens.findIndex(m => m.idEnvio === msg.idEnvio);
        this.contato.mensagens[i] = msg;
        this.contatoLocalProvider.atualizarMensagem(this.contato.idContato, msg);
        this.contatoProvider.enviarMensagemImagem(this.contato.idContato, this.brComService.getIdDevice(), url).subscribe(
          (idEnvio: number) => {
            this.contato.mensagens.find(m => m.idEnvio === msg.idEnvio).idEnvio = idEnvio;
            this.contatoLocalProvider.atualizarMensagemEnviada(this.contato.idContato, msg.idEnvio, idEnvio);
          }, (error) => {
            this.atualizarMensagemComFalhaNoEnvio(msg);
          }
        )
      }, error => {
        console.log(error)
      }
    )
  }

  public enviarArquivo(file: File): void {
    const arquivo: ArquivoMensagem = {
      nome: file.name,
      mime: file.type,
      link: ""
    }
    const msg = this.criarMensagemArquivoEnvio(this.contato.idUsuario, arquivo);
    this.adicionarNovaMensagem(msg);
    this.mensagemProvider.uploadFirebase(file).then(
      url => {
        msg.arquivo.link = url;
        const i = this.contato.mensagens.findIndex(m => m.idEnvio === msg.idEnvio);
        this.contato.mensagens[i] = msg;
        this.contatoLocalProvider.atualizarMensagem(this.contato.idContato, msg);
        this.contatoProvider.enviarMensagemArquivo(this.contato.idContato, this.brComService.getIdDevice(), msg.arquivo).subscribe(
          (idEnvio: number) => {
            this.contato.mensagens.find(m => m.idEnvio === msg.idEnvio).idEnvio = idEnvio;
            this.contatoLocalProvider.atualizarMensagemEnviada(this.contato.idContato, msg.idEnvio, idEnvio);

          }, (error) => {
            this.atualizarMensagemComFalhaNoEnvio(msg);
          }
        )
      }, error => {
        console.log(error);
      }
    )
  }

  private adicionarNovaMensagem(msg: Mensagem): void {
    if (!this.contato.mensagens) {
      this.contato.mensagens = [];
    }
    this.contato.mensagens.push(msg);
    this.changeDetectorRef.detectChanges();
    this.scrollBottom(this.content);
    this.contatoLocalProvider.adicionarNovaMensagem(this.contato.idContato, msg);
  }

  public getImagemUsuario(): string {
    return this.obterImagemComHash(this.contato.hashFoto);
  }

  public trackBy(index: number, msg: Mensagem) {
    if (!msg) {
      return null;
    }
    return  `${index}:${msg.statusMensagemRecebida}:${msg.statusMensagemLida}:${msg.idEnvio}:${msg.pendente}:${msg.falhaNoEnvio}`;
  }
}



// WEBPACK FOOTER //
// ./src/pages/conversa-contato/conversa-contato.ts